import { compose, createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk as thunkMiddleware } from "redux-thunk";
import { saveState, loadState, removeState } from './localStorage';
import appReducer from "../redux/reducers";
import { authConstant, boardsConstant, userAgencyConstant } from "../redux/constants";
import {
  setUserBoardFilterPreferences,
  setUserDocPreferences,
  isFlozyMobileApp
} from "../utils";
import history from "../config/history";

const rootReducer = (state, action) => {
  if (action.type === authConstant.LOGOUT_S) {
    state = undefined;
    // remove reducer data on in local storage
    removeState()
  } else if (action.type === authConstant.USER_LOGIN_R) {
    // remove reducer data on in local storage
    removeState()
  } else if (action.type === userAgencyConstant.UPDATE_USER_AGENCY_S) {
    state = undefined
    removeState()
    history.push('/home')
  } else if (action.type === "RESET") {
    // Reset state values
    state = undefined
  } else { }

  return appReducer(state, action);
};

const preferenceMiddleware = ({ getState }) => {
  return (next) => (action) => {
    // Save the reducer data on all dispatch
    //remove loading state
    const store_data = getState()
    const updated_store = {}

    if (!isFlozyMobileApp()) {
      // Add the reducer here to use the persist store
      try {
        updated_store["auth"] = store_data?.auth || {}
        updated_store["chatv2"] = store_data?.chatv2 || {}
        delete updated_store["scrollBtn"]
        // delete updated_store["chatv2"]["ai_streaming"]
        updated_store["schedule"] = store_data?.schedule || {}
        updated_store["docs"] = store_data?.docs || {}
        updated_store["media"] = store_data?.media || {}
        updated_store["clientMedia"] = store_data?.clientMedia || {}
        updated_store["workSpaceCloning"] = store_data?.workSpaceCloning || {}
        if (action.type === "CLONING_PROGRESS_UPDATE_C") {
          delete updated_store.workSpaceCloning;
        }
        if (action.type === "CLONING_NOTIFY_DATA_RESET_S") {
          delete updated_store.workSpaceCloning;
        }
        saveState(updated_store);

        // temp fix
        setTimeout(() => {
          const store_data = getState();
          updated_store["docs"] = store_data?.docs || {};
          saveState(updated_store);
        }, 2000)
      } catch (err) {
        console.log("Persist store error:", err)
      }
    }

    const result = next(action);
    if (action.type === "CLONING_PROGRESS_UPDATE_C") {
      const updated_store = { ...store_data };
      delete updated_store.workSpaceCloning;
      saveState(updated_store)
      return result;
    }
    if (action.type === "CLONING_NOTIFY_DATA_RESET_S") {
      const updated_store = { ...store_data };
      delete updated_store.workSpaceCloning;
      saveState(updated_store);
      return result;
    }
    if (action.type === boardsConstant.SAVE_BOARD_FILTER
      || action.type === boardsConstant.UPDATE_BOARD_FILTER) {
      const { boards: { saved_filters, board_id } } = getState()
      setUserBoardFilterPreferences(board_id, saved_filters)
    }

    return result;
  };
};


const enhancer = composeWithDevTools(
  applyMiddleware(
    thunkMiddleware,
    preferenceMiddleware
  )
);

// Added persistant store to save the reducer data into the local storage
const persistedState = loadState() || {}

export default function store(initialState) {
  return createStore(
    rootReducer,
    isFlozyMobileApp() ? initialState : persistedState,
    enhancer
  );
}
